module.exports = Promise.resolve(module.bundle.root("2f2Ok"))